import { styled } from '@styles';

export const Wrapper = styled.div`
  position: relative;
`;
